/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userConglomerateNotificationPreferences.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

/**
 * The HTTP endpoint for the [GetConglomerateNotificationPreferencesApi].
 *
 * [Endpoint] has a single [Endpoint.path] parameter ex. "users/me"
 */
internal val GetConglomerateNotificationPreferencesEndpoint = Endpoint(path = "users/me/settings/notifications?page=1&per_page=100")
